import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReviewsMainComponent } from './containers/reviews-main/reviews-main.component';

const routes: Routes = [
  { path: '', component: ReviewsMainComponent }
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReviewsRoutingModule { }
